const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const RangeSlider = require("../core/view/RangeSlider");
const IconButton = require("../core/view/IconButton");
const Tooltip = require("../core/view/Tooltip");
const AssetsUtil = require("../core/util/AssetsUtil");

const styles = require("./styles/PlaybackSpeedButton.css");

module.exports = createReactClass({
	displayName: "PlaybackSpeedButton",

	propTypes: {
		playbackRate: PT.number.isRequired,
		onPlaybackRateChange: PT.func.isRequired,
		className: PT.string,
	},

	getInitialState: function() {
		return {
			isDialogOpen: false,
		};
	},

	componentDidMount: function() {
		document.addEventListener("click", this.handleDocumentClick);
	},

	componentWillUnmount: function() {
		document.removeEventListener("click", this.handleDocumentClick);
	},

	handleDocumentClick: function(event) {
		// Close dialog if clicking outside of it
		if (this.containerRef && !this.containerRef.contains(event.target)) {
			this.setState({isDialogOpen: false});
		}
	},

	toggleDialog: function(event) {
		event.stopPropagation();
		this.setState({isDialogOpen: !this.state.isDialogOpen});
	},

	closeDialog: function() {
		this.setState({isDialogOpen: false});
	},

	getSliderValue: function() {
		return this.rateToValue(this.props.playbackRate);
	},

	handleSliderChange: function(value) {
		this.props.onPlaybackRateChange(value);
	},

	handleSlowClick: function() {
		const sliderValue = this.getSliderValue();
		this.onSliderChange(Math.max(sliderValue - 0.1, 0));
	},

	handleFastClick: function() {
		const sliderValue = this.getSliderValue();
		this.onSliderChange(Math.min(sliderValue + 0.1, 2));
	},

	/**
	 * Convert slider value (0-2.1) to playback rate.
	 *
	 * Makes the left side of the slider correspond to 0.25-1x speed, and the right side to 1-2x speed, skipping 2.1.
	 **/
	valueToRate: function(value) {
		if (value < 1) {
			return value * 0.75 + 0.25;
		} else {
			return Math.min(value, 2);
		}
	},

	/**
	 * Convert playback rate to slider value (0-2.1).
	 *
	 * See valueToRate for details.
	 **/
	rateToValue: function(rate) {
		if (rate < 1) {
			return (rate - 0.25) / 0.75;
		} else {
			return Math.min(rate, 2);
		}
	},

	getFormattedPlaybackRate: function() {
		// Round to 3 decimal places to avoid floating point precision issues
		const result = this.props.playbackRate.toFixed(3);
		// Remove trailing zeros
		return result.replace(/\.?0+$/, "");
	},

	onSliderChange: function(value) {
		const rate = this.valueToRate(value);
		this.handleSliderChange(rate);
	},

	render: function() {
		const {playbackRate} = this.props;
		const {isDialogOpen} = this.state;
		return (
			<div className={styles.container} ref={ref => (this.containerRef = ref)}>
				<Tooltip
					tooltipText={`Playback speed: ${this.getFormattedPlaybackRate()}x`}
					size="medium"
					direction="bottom-right"
				>
					<IconButton
						className={styles.button}
						iconImgPath={AssetsUtil.getTheaterIcon("playback-speed")}
						handleClick={this.toggleDialog}
						ariaLabel="Playback speed controls"
					/>
				</Tooltip>
				{isDialogOpen && (
					<div className={styles.popup}>
						<div className={styles.content}>
							<div className={styles.labels}>
								<IconButton
									className={styles.labelButton}
									iconImgPath={AssetsUtil.getTheaterIcon("playback-slow")}
									handleClick={this.handleSlowClick}
									ariaLabel="Decrease playback speed"
								/>
								<span className={styles.labelCircle}>●</span>
								<img
									className={styles.labelCarat}
									alt=""
									src={AssetsUtil.getTheaterIcon("carat-down")}
								/>
								<span className={styles.labelCircle}>●</span>
								<IconButton
									className={styles.labelButton}
									iconImgPath={AssetsUtil.getTheaterIcon("playback-fast")}
									handleClick={this.handleFastClick}
									ariaLabel="Increase playback speed"
								/>
							</div>
							<div className={styles.sliderContainer}>
								<RangeSlider
									className={styles.slider}
									value={this.rateToValue(playbackRate)}
									// Slider values don't match playback rates, so that 1.0x is at the middle of the slider - see valueToRate and rateToValue
									min={0}
									max={2.1} // There's a bug where the slider itself isn't symmetrical, so we need to add a bit of padding
									tooltip={false}
									step={0.1}
									orientation="horizontal"
									onChange={this.onSliderChange}
									handleClassName={styles.sliderHandle}
									aria-label="Playback speed slider"
									aria-valuetext={`Current speed: ${this.getFormattedPlaybackRate()}x`}
									aria-valuemin={0.25}
									aria-valuemax={2}
								/>
							</div>
						</div>
					</div>
				)}
			</div>
		);
	},
});
